import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Input extends PureComponent {
  render() {
    const { className, cell, ...others } = this.props;
    const cls = classNames({
      "weui-input": true,
      "weui-cell__control": cell,
      "weui-cell__control_flex": cell
    }, className);

    return (
      <input className={ cls } { ...others } />
    );
  }
}
